import {
  Box,
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography
} from '@mui/material'
import { FC, useState } from 'react'
import { flexcol, flexItemRight, inputFiledStyle } from '../../global'
import { CustomDialog } from '../CustomDialog'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 3.5 + ITEM_PADDING_TOP,
      width: '25%'
    }
  },
  MenuListProps: { sx: { minWidth: '100%', whiteSpace: 'normal !important' } }
}

interface SendANotificationProps {
  open: boolean
  onClose: () => void
  requestType: string
  setRequestType: any
  logMessage: string
  setLogMessage: any
  onPrimaryButtonClick: () => void
  onSecondaryButtonClick: () => void
}

export const SendANotification: FC<SendANotificationProps> = ({
  open,
  onClose,
  requestType,
  setRequestType,
  logMessage,
  setLogMessage,
  onPrimaryButtonClick,
  onSecondaryButtonClick
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setLogMessage(event.target.value)
  }
  return (
    <CustomDialog
      title='Confirm Revision Request'
      primaryButtonText='Apply'
      secondaryButtonText='Cancel'
      open={open}
      onClose={onClose}
      additionalJSX={
        <>
          <Box style={flexcol} sx={{ width: '100%', my: 2 }}>
            <Typography
              sx={{
                fontSize: '16px',
                fontWeight: '400',
                textAlign: 'left',
                lineHeight: '22px',
                mb: '16px'
              }}
            >
              Please add a revision request if necessary
            </Typography>

            <Typography
              sx={{
                fontSize: '20px',
                fontWeight: '500',
                textAlign: 'left',
                lineHeight: '22px'
              }}
            >
              Request
            </Typography>

            <FormControl
              size='small'
              sx={{
                '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline':
                  {
                    borderColor: '#006BD7'
                  },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderRadius: '8px'
                }
              }}
            >
              <Select
                value={requestType}
                onChange={(event: SelectChangeEvent) =>
                  setRequestType(event.target.value)
                }
                MenuProps={MenuProps}
                sx={{ textAlign: 'left', ml: -1.5 }}
              >
                <MenuItem disabled value='Select'>
                  Select
                </MenuItem>
                <MenuItem value='Add Program Office phone number'>
                  Add Program Office phone number
                </MenuItem>
                <MenuItem value='Spell out acronyms'>
                  Spell out acronyms
                </MenuItem>
                <MenuItem value='Custom'>Custom</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Box style={flexcol} sx={{ width: '100%' }}>
            {requestType === 'Custom' && (
              <Box>
                <Typography
                  sx={{
                    fontSize: '20px',
                    fontWeight: '500',
                    textAlign: 'left',
                    lineHeight: '22px'
                  }}
                >
                  Log Message
                </Typography>
              </Box>
            )}
            <Box style={flexItemRight}>
              {requestType === 'Custom' && (
                <Box
                  sx={{
                    flex: 1,
                    ml: -1.25,
                    mr: 2.5,
                    width: { lg: '23rem', xs: '100%' }
                  }}
                >
                  <TextField
                    style={inputFiledStyle}
                    sx={{
                      bgcolor: 'white',
                      '.MuiOutlinedInput-root.Mui-focused': {
                        fieldset: { borderColor: '#006BD7' }
                      },
                      [`& fieldset`]: {
                        borderRadius: '8px'
                      }
                    }}
                    name='notes'
                    multiline
                    placeholder='Enter a custom message'
                    fullWidth
                    size='small'
                    value={logMessage}
                    onChange={handleChange}
                    InputLabelProps={{ shrink: true }}
                  />
                </Box>
              )}
            </Box>
          </Box>
        </>
      }
      onPrimaryButtonClick={onPrimaryButtonClick}
      onSecondaryButtonClick={onSecondaryButtonClick}
      disablePrimaryButton={
        requestType === 'Select' ||
        (requestType === 'Custom' && !logMessage.trim())
      }
    />
  )
}
